import { render } from "./SocialMediaInfoView.vue?vue&type=template&id=f83e5a12&scoped=true"
import script from "./SocialMediaInfoView.vue?vue&type=script&lang=js"
export * from "./SocialMediaInfoView.vue?vue&type=script&lang=js"

import "./SocialMediaInfoView.vue?vue&type=style&index=0&id=f83e5a12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83e5a12"]])

export default __exports__